// Transliteration under Arabic, switched on/off in one place (remembered on this device) and
// shared by the Arabic Lab, Flashcards and the Research rail. Readings come from readingFor():
// a reading already attached to the item, else the user's own from their AMAU lesson notes, else
// a rule-based reading of vowelled Arabic. Notes and the editor are never touched.
import {useEffect,useSyncExternalStore} from 'react'
import {getCourse} from './arabicCourse'
import {buildNotesIndex,readingFor,readRoot,type NotesIndex} from './translit'
import './translit.css'

const KEY='dawwin-translit'
const listeners=new Set<()=>void>()
const emit=()=>listeners.forEach(fn=>fn())
const subscribe=(fn:()=>void)=>{listeners.add(fn);return()=>{listeners.delete(fn)}}
let enabled=(()=>{try{return localStorage.getItem(KEY)!=='off'}catch{return true}})()
let notes:NotesIndex|null=null,loading=false

export function setTranslitEnabled(on:boolean){enabled=on;try{localStorage.setItem(KEY,on?'on':'off')}catch{}emit()}
export const useTranslitEnabled=()=>useSyncExternalStore(subscribe,()=>enabled)

// The course items (extracted read-only from the user's notes) are fetched once per page load.
function loadNotes(){if(loading||notes)return;loading=true;getCourse().then(c=>{notes=buildNotesIndex(c.items||[])}).catch(()=>{notes=buildNotesIndex([])}).finally(()=>emit())}
function useNotesIndex(){const index=useSyncExternalStore(subscribe,()=>notes);useEffect(loadNotes,[]);return index}

export function useArabicReading(arabic:string,given?:string|null){const on=useTranslitEnabled(),index=useNotesIndex();return on?readingFor(arabic,index,given):''}

type Props={text:string;given?:string|null;root?:boolean;className?:string}
export function Translit({text,given,root,className}:Props){
 const on=useTranslitEnabled(),index=useNotesIndex()
 if(!on)return null
 const reading=root?readRoot(text):readingFor(text,index,given)
 return reading?<span className={'dawwin-translit'+(className?' '+className:'')} lang="en" dir="ltr">{reading}</span>:null
}

export function TranslitToggle({className}:{className?:string}){
 const on=useTranslitEnabled()
 return <button type="button" className={'dawwin-translit-toggle'+(className?' '+className:'')} aria-pressed={on} title="Show a Latin reading under Arabic" onClick={()=>setTranslitEnabled(!on)}>Transliteration {on?'on':'off'}</button>
}
